import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import servicesBoxStyles from './servicesBoxStyles.module.scss';
import { actions } from './../../../state';
import Boxes from './../boxes/boxes';
import { InputElement } from './../../../components';
import { formattedDevices } from '../locations.utils';

const CarMatCleaner = ({ dispatch, data, requestError }) => {
  const [values, setValues] = useState({
    carMatCleanerPrice: data !== null ? data.options[0].price / 100 : '',
    carMatCleanerDuration: data !== null ? data.time : '',
  });

  const [devices, setBoxesValues] = useState(data === null ? [] : data.devices);

  const handleInputChange = ({ target: { name, value } }) => {
    setValues({ ...values, [name]: value });
  };

  useEffect(() => {
    const options = [
      {
        type: 401,
        price: values.carMatCleanerPrice * 100,
      },
    ];
    const data = {
      time: values.carMatCleanerDuration,
      options,
      devices: formattedDevices(devices),
    };
    dispatch(actions.addEditServices.pushCarMatCleanerAction(data));
  });

  const handleStateFromBoxes = x => {
    setBoxesValues(x);
  };

  return (
    <div className={servicesBoxStyles.mainContainer}>
      <table className={servicesBoxStyles.container}>
        <thead>
          <tr>
            <th>Pavadinimas</th>
            <th>Kaina su PVM (EUR)</th>
            <th>Trukmė (min)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Kilimėlių plovimo paslaugos</td>
            <td className={servicesBoxStyles.pricePlanInput}>
              <InputElement
                name="carMatCleanerPrice"
                type="number"
                onChange={handleInputChange}
                value={values.carMatCleanerPrice}
                invalid={requestError && !values.carMatCleanerPrice}
                placeholder="0.00"
                min="0"
                step="0.01"
              />
            </td>
            <td className={servicesBoxStyles.pricePlanInput}>
              <InputElement
                name="carMatCleanerDuration"
                type="number"
                onChange={handleInputChange}
                value={values.carMatCleanerDuration}
                invalid={requestError && !values.carMatCleanerDuration}
                placeholder="0"
                min="0"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <Boxes
        handleStateFromBoxes={handleStateFromBoxes}
        devices={data === null ? [] : data.devices}
        location="car_mat_cleaner"
        requestError={requestError}
      />
    </div>
  );
};

CarMatCleaner.propTypes = {
  dispatch: PropTypes.func,
  data: PropTypes.shape({
    devices: PropTypes.array.isRequired,
    id: PropTypes.number.isRequired,
    options: PropTypes.array.isRequired,
    status: PropTypes.number.isRequired,
    type: PropTypes.number.isRequired,
  }),
};

export default connect()(CarMatCleaner);
